export default __webpack_public_path__ + "static/media/offer4.38bb7dbd.jpg";